import {createAnnotation} from './utils/createAnnotation'

/**
 * The annotation builder for arbitrary HTML attributes of a component.
 */
export const validation = createAnnotation('validation')
